import { render, staticRenderFns } from "./TheDownloadBtn.vue?vue&type=template&id=40063a3f&scoped=true&"
import script from "./TheDownloadBtn.vue?vue&type=script&lang=js&"
export * from "./TheDownloadBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40063a3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
